import { FETCH_WITH_TOKEN } from '@services/react-query/config'
import { GET_NOTIFICATIONS_URL } from '@services/react-query/urls/user'
import { useInfiniteQuery } from '@tanstack/react-query'
import { Notification } from '@type/notifications'

interface ResData {
  notifications: Notification[]
  totalCount: number
  totalPages: number
  unreadCount: number
}

const useGetNotifications = (limit = 10, userId = '') => {
  return useInfiniteQuery<ResData>({
    queryKey: ['notifications', limit, userId],
    queryFn: ({ pageParam }) =>
      FETCH_WITH_TOKEN(
        GET_NOTIFICATIONS_URL(userId, pageParam as number, limit)
      ),
    getNextPageParam: (lastPage, allPages) => {
      if (!allPages?.length || !lastPage?.totalPages) return undefined
      const nextPage = allPages.length + 1
      return nextPage <= lastPage.totalPages ? nextPage : undefined
    },
    initialPageParam: 1,
    enabled: !!userId,
    gcTime: 1000 * 60 * 10, // 10 minutes
  })
}

export default useGetNotifications
